
import { Component, Prop } from 'vue-property-decorator'
import BaseBreadcrumbsGenerator from './BaseBreadcrumbsGenerator.vue'
import { SimpleBreadcrumbWithCount } from '../search/types'
import { Breadcrumb } from '~/apps/search/schemas'
import { MetaInfo } from 'vue-meta'

@Component<SearchBreadcrumbs>({
  head: function () {
    return this.head()
  },
})
export default class SearchBreadcrumbs extends BaseBreadcrumbsGenerator {
  // this is new breadcrumbs coming from search meta service
  // it has full urls not hierarchy paths and so can't use the counts
  @Prop()
    breadcrumbs: Breadcrumb[]

  @Prop({ default: true })
    showSchema: boolean

  @Prop({ required: false, default: () => ({}) })
    counts: Record<string, number>

  get breadcrumbsInternal2() {
    const newBreadcrumbs: SimpleBreadcrumbWithCount[] = []
    for (const breadcrumb of this.breadcrumbs) {
      const count = breadcrumb.hierarchyPath
        ? this.counts[breadcrumb.hierarchyPath]
        : undefined
      if (breadcrumb.name !== 'Pitchup.com') {
        newBreadcrumbs.push({
          label: breadcrumb.name,
          url: breadcrumb.url,
          count,
          hierarchyLevel: breadcrumb.hierarchyLevel,
          hierarchyPath: breadcrumb.hierarchyPath,
        })
      }
    }
    return newBreadcrumbs
  }

  head(): MetaInfo {
    if (this.showSchema) {
      return {
        script: [
          {
            type: 'application/ld+json',
            body: true,
            json: {
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: this.breadcrumbs.map((breadcrumb, index) => {
                return {
                  '@type': 'ListItem',
                  position: index + 1,
                  item: {
                    '@id': `https://${this.$config.public.envUrl}${breadcrumb.url}`,
                    name: breadcrumb.name,
                  },
                }
              }),
            },
          },
        ],
      }
    } else {
      return {}
    }
  }
}
